import { Box, Typography } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';

import ControlledNumberField from '~components/Form/ControlledNumberField';
import { ParameterWaitDTMF } from '~pages/SipConfiguration/domain';

import BaseNode from '../BaseNode';
import { ContactFlowNodeProps } from '..';

export default function WaitDTMFNode(props: ContactFlowNodeProps) {
  const form = useForm<ParameterWaitDTMF>({
    defaultValues: props.data.parameter.waitDTMF,
  });
  return (
    <BaseNode
      {...props}
      title='Wait DTMF'
      parameterForm={form}
      renderParameterForm={(waitDTMF) => (
        <>
          <Typography>Digits: {waitDTMF?.digits ?? '--'}</Typography>
          <Typography>Timeout (ms): {waitDTMF?.timeoutMS ?? '--'}</Typography>
        </>
      )}
      transformParameter={(waitDTMF) => ({ waitDTMF })}
      renderEditParameter={({ control }) => (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}>
          <ControlledNumberField name='digits' control={control} label='Digits' defaultValue='' />

          <ControlledNumberField name='timeoutMS' control={control} label='Timeout (ms)' defaultValue='' />
        </Box>
      )}
    />
  );
}
